import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
    useRef,
} from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Modal,
    Table,
    Alert,
    Image
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
 
import { UpdateMappingModal } from "./UpdateMappingModal";
import { AddMappingModal } from "./AddMappingModal";

import "./crossReference.css";
import "../../reusable-components/InputFields/elements/customelements.css"
import { ToastContainer, toast } from "react-toastify";
import { logout, capitalizeFirstLetter } from "../../utils";
import { OffCanvasDrawer } from "./OffCanvasDrawer";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

/**
* A grid cell renderer button.
* @param {*} editCellProps: editCellProps include the selected row data for editing.
* @returns A button for editing the row in grid.
*/
const BtnCellRenderer = (editCellProps) => {
    // console.log("BRN CELL RENDERER PROPS: ", editCellProps)
    const referenceType = editCellProps.node.data.MappingType
    const editClick = () => {
        editCellProps.setModal(true);
        editCellProps.selectedRow(editCellProps.data);
    }

    return (referenceType === "Fields" ? <Button className="grid-button" onClick={() => editClick()}><Icon.PencilSquare /></Button> : <></>);
}

/**
* A grid cell renderer button.
* @param {*} params: props include the selected row data for editing.
* @returns A button for editing the row in grid.
*/
export const HasDataFieldsRenderer = (params) => {
    const hasFieldData = []
    params.dataSource.forEach((obj) =>
        obj.MappingGroup === params.data.MappingGroup && obj.MappingType === "Data"
            ?
            hasFieldData.push(true)
            :
            hasFieldData.push(false)
    )
    return (hasFieldData.includes(true) ? <Icon.CheckCircleFill className="done" /> : <></>);
}

export const MappingGrid = (props) => {
    // props.setEditedRows([...props.editedRows, event.rowIndex]);
    const [dataSource, setDataSource] = useState([])
    const [gridRows, setGridRows] = useState([])
    useEffect(() => {
        setDataSource(props.dataSource)
    }, [props.dataSource])
    useEffect(() => {
        const gridRowsTemp = []
        props.dataSource.forEach((obj) =>
            obj.MappingType === "Fields"
                ?
                gridRowsTemp.push(obj)
                :
                false
        )
        setGridRows(gridRowsTemp)
    }, [props.dataSource])

    const [sourceEndPoints, setSourceEndPoints] = useState(null)
    const [targetEndPoints, setTargetEndPoints] = useState(null)
    useEffect(() => {
        const sep = []
        const tep = []
        for (let obj in props.endPoints.SourceEndpoints) {
            if (props.endPoints.SourceEndpoints[obj] != null) {
                sep.push(props.endPoints.SourceEndpoints[obj].EndPointName)
            } else {
                continue
            }
        }
        for (let obj in props.endPoints.TargetEndpoints) {
            if (props.endPoints.TargetEndpoints[obj] != null) {
                tep.push(props.endPoints.TargetEndpoints[obj].EndPointName)
            } else {
                continue
            }
        }

        setSourceEndPoints(sep)
        setTargetEndPoints(tep)
    }, [props.endPoints])

    const [selectedFirmJob, setSelectedFirmJob] = useState()
    useEffect(() => {
        setSelectedFirmJob(props.selectedFirmJob)
    }, [props.selectedFirmJob])

    const [sourceVendor, setSourceVendor] = useState()
    useEffect(() => {
        setSourceVendor(props.sourceVendor)
    }, [props.sourceVendor])

    const [destinationVendor, setDestinationVendor] = useState()
    useEffect(() => {
        setDestinationVendor(props.destinationVendor)
    }, [props.destinationVendor])

    const [updateModalShow, setUpdateModalShow] = useState(false);
    const [addModalShow, setAddModalShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const [editedRows, setEditedRows] = useState([]);
    const [deleteMappings, setDeleteMappings] = useState(false);
    
    const [uploadedData, setUploadedData] = useState([]);
    const [open, setOpen] = useState(false);
    const [bulkUpload, setBulkUpload] = useState(false)
    const [deleteMappingFlag, setDeleteMappingFlag] = useState()
    // get grid reference
    const crossReferenceGridRef = useRef();

    let contextGridApi;
    const onContextGridReady = useCallback((params) => {
        contextGridApi = params.api
        contextGridApi.closeToolPanel();
        dataSource && setDataSource(dataSource);
    })

    const onFirstDataRendered = useCallback((params) => {
        crossReferenceGridRef.current.api.sizeColumnsToFit();
    }, []);

    const onSelectionChanged = () => { const selectedData = crossReferenceGridRef.current.api.getSelectedRows() };
    const [columnDefs, setColumnDefs] = useState([]);

    useEffect(() => {
        setColumnDefs(
            [
                {
                    field: "",
                    width: 50,
                    maxWidth: 50,
                    cellRenderer: BtnCellRenderer,
                    cellRendererParams: {
                        setModal: setUpdateModalShow,
                        selectedRow: setSelectedRowData
                    },
                    pinned: 'left'
                },
                // { field: "FirmVendorMappingId", hide: true, rowGroup: true },
                // {field: "MappingName", headerName:"Mapping name", hide: true, rowGroup: true },
                {
                    field: "SourceField",
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    enablePivot: false,
                    valueSetter: (params) => {
                        const newValue = params.newValue;
                        const allRowData = params.api
                            .getModel()
                            .rowsToDisplay.map((row) => row.data);
                        const isDuplicate = allRowData.some((row) => {
                            return row.SourceField === newValue;
                        });

                        if (isDuplicate) {
                            return false; // prevent value from being set
                        } else {
                            params.data.SourceField = newValue; // allow value to be set
                            return true;
                        }
                    },
                    sortable: true,
                    filter: true,
                },
                { field: "DestinationField", sortable: true, filter: true },
                {
                    field: "Format",
                    valueFormatter: (params) => {
                        return (params.data.Format === "" ? "" : params.data.Format)
                    }
                },
                {
                    field: "",
                    headerName: "Data Fields",
                    cellRenderer: HasDataFieldsRenderer,
                    cellRendererParams: {
                        dataSource: props.dataSource
                    },
                    sortable: true,
                    filter: true,
                },
                {
                    field: "Level",
                    headerName: "Level",                    
                    valueFormatter: (params) => getLevelLabel(params.value, props.vendorleveloptions),
                    maxWidth: 300
                }
            ]
        )
    }, [props.dataSource])


    const getLevelLabel = (level, vendorLevelOptions) => {
        // console.log(vendorLevelOptions, "----", level)
        if (!vendorLevelOptions || vendorLevelOptions.length <= 1 || !level) return "";
        
        // Find the step at the given level
        const sourceVendor = vendorLevelOptions.find(v => v.StepNumber === level);
        const destinationVendor = vendorLevelOptions.find(v => v.StepNumber === level + 1);
    
        // Ensure both vendors exist before returning a label
        return sourceVendor && destinationVendor 
            ? `${sourceVendor.VendorName} to ${destinationVendor.VendorName}`
            : "";
    };
    


    // const GroupRowInnerRenderer= (props) => {
    // console.log("PROPS NODE: ", props.node.key)

    //   const node = props.node;


    //   const refreshUi = () => {
    //     const node = props.node;
    //   };

    //   const dataChangedListener = () => refreshUi();

    //   useEffect(() => {
    //     props.api.addEventListener('cellValueChanged', dataChangedListener);
    //     props.api.addEventListener('filterChanged', dataChangedListener);

    //     return () => {
    //       props.api.removeEventListener('cellValueChanged', dataChangedListener);
    //       props.api.removeEventListener('filterChanged', dataChangedListener);
    //     };
    //   }, []);

    //   return (
    //     <div style={{ display: 'inline-block' }}>
    //       {/* {img}
    //       <span className="groupTitle">{countryName}</span>
    //       <span
    //         className="medal gold"
    //         aria-label={`${countryName} - ${goldCount} gold medals`}
    //       >
    //         <i className="fas fa-medal"></i>
    //         {goldCount}
    //       </span>
    //       <span
    //         className="medal silver"
    //         aria-label={`${countryName} - ${silverCount} silver medals`}
    //       >
    //         <i className="fas fa-medal"></i>
    //         {silverCount}
    //       </span>
    //       <span
    //         className="medal bronze"
    //         aria-label={`${countryName} - ${bronzeCount} bronze medals`}
    //       >
    //         <i className="fas fa-medal"></i>
    //         {bronzeCount}
    //       </span> */}
    //     </div>
    //   );
    // };

    // const groupRowRendererParams = useMemo(() => {
    //     return {
    //       innerRenderer: GroupRowInnerRenderer,
    //       suppressCount: true
    // };
    // }, []);


    const sortable = true;
    const filter = true;
    const resizable = true;


    const handleAddMapping = () => {
        onResetFilters();
        setAddModalShow(true)
        // crossReferenceGridRef.current.api.applyTransaction({
        //     add: [{}],
        //     addIndex: 0,
        // });

        // crossReferenceGridRef.current.api.forEachNode((node) => {
        //     node.data.index = node.rowIndex;
        // });

        // editedRows.length && setEditedRows(editedRows.map((el) => el + 1));
    };

   


    const handleDeleteMapping = () => {
        const selectedRows = crossReferenceGridRef.current.api.getSelectedRows();
        if (selectedRows && selectedRows.length) {
            console.log("DELETED ROWS : ", selectedRows);

            setDeleteMappings(true);
        } else {
            toast.error(
                      "No rows selected",
                      {
                          position: "bottom-right",
                          autoClose: 2500,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          className: "toastify-color-error",
                      }
                  );
            // alert("No rows selected");
        }
    };

    const deleteMappingCall = async() => {
        setDeleteMappingFlag(true)
        const selectedRows = crossReferenceGridRef.current.api.getSelectedRows();
        selectedRows &&
            crossReferenceGridRef.current.api.applyTransaction({
                remove: selectedRows,
            });

        let dataToBeDeleted = selectedRows.map((el) => {
            return {
                FirmVendorMappingId: el.FirmVendorMappingId,
            };
        });
        console.log("DATA TO BE DELETED: ", dataToBeDeleted)
        const _ = await makeCygnusApiCall({
            type: "DELETE",
            payload: dataToBeDeleted,
            url: "/mapping/",
            show_message: true,
            customized_success_message: "Changes to the mapping were successfully saved.",
            customized_failure_message: "Unable to delete your mapping, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while deleting the mapping, please contact support and attach a screenshot.",
            isblob: false
          })
        setDeleteMappings(false);
        setDeleteMappingFlag(false)
    };


    const saveData = () => {

    };

    const handleSaveAndAdd = () => {
        console.log("Handle save and upload called back")
        const addedData =
            uploadedData &&
            dataSource &&
            uploadedData
                .filter(
                    (item) =>
                        dataSource.map((el) => el.SourceField).includes(item.SourceField) ==
                        false
                )
                .map((el) => {
                    return {
                        DestinationField: el.DestinationField,
                        SourceField: el.SourceField,
                        Active: el.Active == "True" ? "Y" : "N",
                        SourceVendorCode: sourceVendor,
                        DestinationVendorCode: destinationVendor,
                        ReferenceType: el.ReferenceType,
                        FlowId: el.FlowId
                    };
                });
    };

    const onResetFilters = () => {
        crossReferenceGridRef.current.api.setFilterModel({});
    };

    return (
        <>
            <AddMappingModal
                show={addModalShow}
                onHide={() => setAddModalShow(false)}
                sourceVendor={sourceVendor}
                destinationVendor={destinationVendor}
                addDataMapping={(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, flowStepNumber) => {
                    props.addDataMapping(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, flowStepNumber)
                    setAddModalShow(false)
                    setTimeout(() => {
                        props.getAllVendorMappings(selectedFirmJob.id)
                    }, 2000);
                }}
                sourceEndPoints={sourceEndPoints}
                targetEndPoints={targetEndPoints}
                vendorleveloptions={props.vendorleveloptions}
            />
            {updateModalShow && <UpdateMappingModal
                show={updateModalShow}
                selectedrowdata={selectedRowData}
                onHide={() => setUpdateModalShow(false)}
                sourceVendor={sourceVendor}
                destinationVendor={destinationVendor}
                updateDataMapping={(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, removedMapping, FirmVendorMappingId, flowStepNumber) => {
                    props.updateDataMapping(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, removedMapping, FirmVendorMappingId, flowStepNumber)
                    setUpdateModalShow(false)
                    setTimeout(() => {
                        props.getAllVendorMappings(selectedFirmJob.id)
                    }, 2000);
                }}
                sourceEndPoints={sourceEndPoints}
                targetEndPoints={targetEndPoints}
                dataSource={dataSource}
                vendorleveloptions={props.vendorleveloptions}
                level={getLevelLabel(selectedRowData.Level, props.vendorleveloptions)}
            />}

            
            <Modal show={deleteMappings} size="lg">
                <Modal.Header>
                    <Modal.Title>Delete </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete the selected Mappings </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setDeleteMappings(false)}
                    >
                        Cancel
                    </Button>
                    <CustomButton
                        progress={deleteMappingFlag}
                        onclick={() => deleteMappingCall()}
                        content={deleteMappingFlag ? "Deleting" : "Delete"}
                        disable={deleteMappingFlag}
                    />
                </Modal.Footer>
            </Modal>
            <Row>
                <Col xs={12} style={{ padding: 0 }}>
                    <Button
                        className="custom-button"
                        style={{ float: "left", margin: "0 0 10px 10px" }}
                        onClick={() => handleAddMapping()}
                    >
                        <Icon.Plus /> Add
                    </Button>
                    <Button
                        className="custom-button"
                        style={{ float: "left", margin: "0 0 10px 10px" }}
                        onClick={() => handleDeleteMapping()}
                    >
                        <Icon.Trash /> Delete
                    </Button>
                    {/*<Button
                        className="custom-button"
                        style={{ float: "left", margin: "0 0 10px 10px" }}
                        onClick={() => setBulkUpload(!bulkUpload)}
                    >
                        <Icon.Upload /> Bulk Upload
                    </Button>*/}
      

                    {/* {editedRows && (
                        <Button
                            style={{ float: "right" }}
                            className="custom-button"
                            onClick={() => saveData()}
                        >
                            Save
                        </Button>
                    )} */}
                </Col>
            </Row>
            <OffCanvasDrawer
                dataSource={dataSource}
                uploadedData={uploadedData}
                setUploadedData={setUploadedData}
                open={open}
                setOpen={setOpen}
                bulkupload={bulkUpload}
                handleSaveAndAdd = {handleSaveAndAdd}
            />
            <AgGridReact
                ref={crossReferenceGridRef}
                rowData={gridRows}
                columnDefs={columnDefs}
                alwaysShowHorizontalScroll={true}
                alwaysShowVerticalScroll={true}
                sideBar={"columns"}
                sortable={sortable}
                filter={filter}
                resizable={resizable}
                onFirstDataRendered={onFirstDataRendered}
                onGridReady={onContextGridReady}
                rowHeight={40}
                suppressRowHoverHighlight={true}
                // singleClickEdit={true}
                suppressRowClickSelection={true}
                rowSelection={'multiple'}
                onSelectionChanged={onSelectionChanged}
                groupDisplayType='groupRows'
                groupDefaultExpanded={1}
                // groupRowRendererParams={groupRowRendererParams}
                animateRows={true}
            />
        </>

    )
}